module.exports = __webpack_public_path__ + "media/images/product_large_images/cashdrawer(600)-34c69cac0e11c23d97966e23cc0555c0.png";